module.exports = __webpack_public_path__ + "static/media/new_york_times.2f2e41ef.svg";